export const homeAssets = {
  homePage: {
    industries: {
      HomePageAgTech: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/AgTech.svg`,
      HomePageEducation: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Education.svg`,
      HomePageEntertainment: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Entertainment.svg`,
      HomePageHealthcare: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Healthcare.svg`,
      HomePageLogistics: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Logistics.svg`,
      HomePageManufacturing: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Manufacturing.svg`,
      HomePageOnDemand: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/onDemand.svg`,
      HomePageRestaurant: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Restaurant.svg`,
      HomePageTravel: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Travel.svg`,
      HomePageInsurance: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Insurance.svg`,
      HomePageOil: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/oil.svg`,
      HomePageRealEstate: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/industry_images/Real-Estate.svg`,
    },
  },
  common: {
    hero: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Hero.webp`,
    texture: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/texture.webp`,
    logoIcon: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo-icon.svg`,
    logoBlue: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo-blue.svg`,
  },
};
